<template>
  <div>
    <header>
      <Header />
    </header>
    <div>
      <div id="main">
        <section class="artWorkCateTop">
          <div v-if="isSelected('/j100v')" class="artWorkCateTopTitle">
            <div class="inner4">
              <h1>日本写真100景＜四季＞2022</h1>
              <p class="titleSub">100 Cultural &amp; Landscape Photos of Japan</p>
            </div><!-- /inner4-->
          </div><!-- /photographersListTitle-->

          <div v-if="isSelected('/j100v')" class="artWorkInfo">
            <div class="inner2">
              <p class="mainTxt">
                依然として新型コロナウイルス感染症（COVID-19）の影響によって、日本を含む世界中の観光業は過去に例がない甚大な被害を受けています。日本の名勝地は、観光業により直接・間接的に支えられていることもあり、今までにないほど厳しい状況に追い込まれています。
              </p>
              <p class="mainTxt">
                この結果、このままでは今までのような写真撮影を楽しめなくなるおそれが高まり続けています。そこで今年も引き続き日本全国の名勝地、観光業の支援も視野に入れたフォトコンテストを開催しました。
              </p>
            </div><!-- /inner2-->
          </div><!-- /artWorkInfo-->

          <div class="artWorkCateTopBody">
            <div class="inner2">
              <div v-if="isSelected('/j100v')" class="listBlock">
                <template v-for="area of areas">
                  <div v-if="!$route.params.area || ($route.params.area == areaAlphabetMap[area.name])" :key="area.id">
                    <h2>{{area.name}}エリア</h2>
                    <div class="listBlockInner">
                      <template v-for="(winner, index) of winnerListByArea(area)">
                        <div :key="winner.id" class="exhibitor" :class="{ rowLast: (index % 5 === 4)}">
                          <div class="thumbnailImg">
                              <router-link :to="workUrl(winner)">
                                <img :src="winner.mainImageUrl" :alt="winner.mainImageTitle" />
                              </router-link>
                          </div>
                          <p v-if="winner.mainImageTitle" class="prefectures">{{winner.mainImageTitle}}</p>
                          <h3 class="wrap"><router-link :to="workUrl(winner)">{{ winner.name }}</router-link></h3>
                        </div>
                      </template>
                    </div><!-- /listBlockInner-->
                  </div>
                </template>
                <div class="inner2 photospot100inner">
                  <div class="photospot100">
                    <h4>日本写真100景フォトスポットサイト</h4>
                    <p>「日本写真100景」の入選作品を地図や季節から探す事ができるサイトです。作品が撮影された場所を緯度・経度から地図上で確認できるほか、一部のフォトスポットにはおすすめの観光情報や作品解説も掲載しています。ぜひご覧ください。</p>
                    <a class="StandardBtn" href="https://japanphotospot.tokyocameraclub.com/" target="_black" onclick="">日本写真100景フォトスポットサイトへ</a>
                  </div>
                </div><!-- /inner2-->
              </div><!-- /listBlock-->

            </div><!-- /inner2-->
          </div><!-- /photographersListBody-->
        </section><!-- /photobook-->

      </div><!-- /main-->
    </div>
    <Footer />
    <div class="actionMenu">
      <UpButton />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Header from '@/components/modules/Header.vue'
import Footer from '@/components/modules/Footer.vue'
import enumMixin from '@/concern/enumMixin'
import constMixin from '@/concern/constMixin'
import UpButton from '@/components/modules/UpButton.vue'

export default {
  mixins: [enumMixin, constMixin], // Enum値, const値の読み込み
  components: {
    Header,
    Footer,
    UpButton
  },
  data () {
    return {}
  },
  computed: {
    ...mapGetters(['winners', 'winnersByAwardType', 'areas'])
  },
  methods: {
    isSelected (str) {
      return this.$route.path.indexOf(str) >= 0
    },
    setTitleAndDescription (to) {
      document.title = to.meta.title ? to.meta.title : ''
      document
        .querySelector('meta[name="description"]')
        .setAttribute('content', to.meta.desc ? to.meta.desc : '')
    },
    winnerList (type) {
      return this.winners.filter((winner) => { return winner.awardType === type })
    },
    winnerListByArea (area) {
      const winners = this.winnerList(this.EnumAwardTypeJapan100Views)
      return winners.filter((winner) => {
        if (this.$route.params.pref) {
          return this.$route.params.pref == this.prefecturesAlphabetMap[winner.mainImageTitle] &&
                  this.prefecturesMap[winner.mainImageTitle] === area.name
        } else {
          return this.prefecturesMap[winner.mainImageTitle] === area.name
        }
      })
    },
    workUrl (winner) {
      let path = ''
      if (winner.awardType == this.EnumAwardTypeJapan100Views) {
        const areaNameJa = this.prefecturesMap[winner.mainImageTitle]
        const areaNameAlpha = this.areaAlphabetMap[areaNameJa]
        const prefNameAlpha = this.prefecturesAlphabetMap[winner.mainImageTitle]
        path = `/j100v/${areaNameAlpha}/${prefNameAlpha}/${winner.id}`
      }
      return path
    },
  },
  mounted () {
    // titleとdescriptionの設定
    this.setTitleAndDescription(this.$route)
  },
  watch: {
    $route: function (to) {
      this.setTitleAndDescription(to)
    }
  }
}
</script>

<style scoped>
</style>
